import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CustomDrawer from '../layout/CustomDrawer';
import { Box, Collapse, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import CancelIcon from '@mui/icons-material/Cancel';

const ErrorList = ({ errors, open, onClose, onProceed, onIgnore }) => {
  const [expandedRow, setExpandedRow] = useState(null);

  const handleRowClick = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const handleDownload = () => {
    console.log('Downloading error report...');
  };

  return (
    <CustomDrawer open={open} onClose={onClose}>
      <Box sx={{ width: '600px', height: '100%', bgcolor: 'white', p: 2 }}>
        <div className="flex justify-between items-center mb-6 px-2">
          <h2 className="text-xl font-medium text-primary">Errors Found</h2>
          <div className="flex items-center gap-4">
            {/* <button
              onClick={handleDownload}
              className="text-red-500 text-sm hover:underline flex items-center gap-1"
            >
              <DownloadIcon fontSize="small" />
              Download Error Report
            </button> */}
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        <div className="space-y-4 mb-6">
          {errors.map((error, index) => (
            <div key={index} className="border-b border-gray-100 last:border-0">
              <div
                onClick={() => handleRowClick(index)}
                className="flex items-start gap-2 p-2 cursor-pointer hover:bg-gray-50"
              >
                <CancelIcon fontSize="small" color="error" className="mt-1" />
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-gray-700">Row Number
                      <span className="text-primary"> "{error.row_index}"</span>
                    </span>
                    <span className="text-gray-700">: Field Name</span>
                    <span className="text-red-500"> "{error.table}"</span>
                  </div>
                  <span className="text-gray-500">Error Message</span>
                  <Collapse in={expandedRow === index}>
                    <div className="mt-2 text-gray-500 text-sm">
                      {/* <p>Error Code: {error.error_code}</p> */}
                      <p className="mt-1">{error.error_message}</p>
                      {/* {error.data && (
                        <div className="mt-2 bg-gray-50 p-2 rounded">
                          {Object.entries(error.data).map(([key, value]) => (
                            <div key={key} className="grid grid-cols-2 gap-2 text-xs py-1">
                              <span className="text-gray-600">{key}:</span>
                              <span className={value === null ? 'text-red-500 italic' : ''}>
                                {value ?? 'null'}
                              </span>
                            </div>
                          ))}
                        </div>
                      )} */}
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end gap-3 mt-4 pt-4 border-t">
          <button
            onClick={onIgnore}
            className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/80"
          >
            Save
          </button>
          {/* <button
            onClick={onProceed}
            className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/80"
          >
            Confirm
          </button> */}
        </div>
      </Box>
    </CustomDrawer>
  );
};

ErrorList.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      row_index: PropTypes.number.isRequired,
      table: PropTypes.string.isRequired,
      error_code: PropTypes.string.isRequired,
      error_message: PropTypes.string.isRequired,
      data: PropTypes.object
    })
  ).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
  onIgnore: PropTypes.func.isRequired
};

export default ErrorList;